import React from "react";

import smsIcon from "../assets/chat.webp";
import emailIcon from "../assets/email.png";
import downloadIcon from "../assets/down.png";
import shareIcon from "../assets/share.png";

const ActionBar = ({ settings, item, submitMessage, handleDownload, handleShare }) => {

 


  return (
    <div className="action-pill">

      {settings?.is_email === "1" && (
        <button
          type="button"
          onClick={() => submitMessage(item, 1)}
          className="pill-btn"
          title="Email"
        >
          <img src={emailIcon} alt="Email" />
        </button>
      )}

      {settings?.is_sms === "1" && (
        <button
          type="button"
          onClick={() => submitMessage(item, 2)}
          className="pill-btn"
          title="SMS"
        >
          <img src={smsIcon} alt="SMS" />
        </button>
      )}

      {/* 🔽 DOWNLOAD */}
      <button
        type="button"
        onClick={()=>handleDownload(item)}
        className="pill-btn"
        title="Download"
      >
        <img src={downloadIcon} alt="Download" />
      </button>

      {/*  SHARE */}
      <button
        type="button"
        onClick={()=>handleShare(item)}
        className="pill-btn"
        title="Share"
      >
        <img src={shareIcon} alt="Share" />
      </button>

    </div>
  );
};

export default ActionBar;
